/* HOVE scroll story: background themes, reveals, counters and the procedural 3D neckband.
   Sections opt in with data-hv-pose / data-hv-theme / data-hv-anchor. */
(function () {
  if (window.__hvBooted) return;
  window.__hvBooted = true;

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const DESIGN = !!(window.Shopify && Shopify.designMode);

  /* ---------- scroll container (Horizon scrolls .page-wrapper on desktop) ---------- */
  let scroller = window;
  function pickScroller() {
    const pw = $('.page-wrapper');
    scroller = pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) && pw.scrollHeight > pw.clientHeight + 1 ? pw : window;
  }
  const scrollTop = () => (scroller === window ? window.scrollY : scroller.scrollTop);
  window.__hvScrollTop = scrollTop;
  window.__hvScrollTo = (el) => {
    const y = el.getBoundingClientRect().top + scrollTop();
    (scroller === window ? window : scroller).scrollTo({ top: y, behavior: REDUCED ? 'auto' : 'smooth' });
  };

  /* ---------- config from the stage section ---------- */
  const stageRoot = () => $('[data-hv-stage-root]');
  let cfg = {};
  function readCfg() {
    const r = stageRoot();
    cfg = r ? { ...r.dataset } : {};
    document.body.classList.toggle('hv-on', !!r);
    if (r) {
      const st = document.body.style;
      [['--hv-dark', 'dark'], ['--hv-light', 'light'], ['--hv-soft', 'soft'], ['--hv-accent', 'accent'], ['--hv-accent-hover', 'accentHover']].forEach(([v, k]) => cfg[k] && st.setProperty(v, cfg[k]));
      if (cfg.fonts === 'hove') {
        st.setProperty('--hv-head', '"Outfit","Avenir Next","Helvetica Neue",system-ui,sans-serif');
        st.setProperty('--hv-body', '"Inter",-apple-system,"Segoe UI",system-ui,sans-serif');
      } else {
        st.removeProperty('--hv-head');
        st.removeProperty('--hv-body');
      }
    }
  }

  /* ---------- sections ---------- */
  let secs = [], chTexts = [], anchors = [];
  function collect() {
    secs = $$('.hv[data-hv-theme]');
    chTexts = secs.map((s) => $('.hv-chapter__text', s));
    measure();
  }
  function measure() {
    pickScroller();
    const vh = innerHeight, st = scrollTop();
    anchors = secs.map((s, i) => {
      const top = s.getBoundingClientRect().top + st;
      const a = s.dataset.hvAnchor;
      if (i === 0 && a === 'start') return 0;
      if (a === 'center') return top + (s.offsetHeight - vh) / 2;
      if (a === 'buy') return top + Math.min(vh * 0.15, Math.max(0, (s.offsetHeight - vh) / 2));
      return top;
    });
  }
  function setTheme() {
    if (!document.body.classList.contains('hv-on')) return;
    const mid = innerHeight * 0.5;
    let th = cfg.otherTheme || 'light', hit = false;
    for (const s of secs) {
      const r = s.getBoundingClientRect();
      if (r.top <= mid && r.bottom > mid) { th = s.dataset.hvTheme; hit = true; break; }
    }
    if (!hit) {
      // between/after story sections: keep the theme of the nearest section above
      for (let i = secs.length - 1; i >= 0; i--) {
        const r = secs[i].getBoundingClientRect();
        if (r.bottom <= mid) { const next = secs[i].closest('.shopify-section')?.nextElementSibling; if (!next || next.querySelector('[data-hv-theme]')) th = secs[i].dataset.hvTheme; break; }
      }
    }
    const f = $('footer');
    if (f && f.getBoundingClientRect().top <= mid) th = cfg.footerTheme || 'dark';
    if (document.body.dataset.hvBg !== th) document.body.dataset.hvBg = th;
  }
  function chapterStates() {
    const y = scrollTop(), vh = innerHeight;
    chTexts.forEach((t, i) => t && t.classList.toggle('on', Math.abs(y - anchors[i]) < vh * 0.42));
  }
  function heroWord() {
    const w = $('[data-hv-hero-word]');
    if (!w || REDUCED) return;
    const hp = Math.min(1, scrollTop() / innerHeight);
    w.style.opacity = Math.max(0, 1 - hp * 1.25).toFixed(3);
    w.style.transform = 'translateY(' + (-hp * 90).toFixed(1) + 'px) scale(' + (1 - hp * 0.1).toFixed(4) + ')';
  }

  /* ---------- pause heavy work while a menu, drawer or popup covers the page ---------- */
  let menuDetails = null;
  function hvPaused() {
    const h = document.documentElement;
    if (h.hasAttribute('scroll-lock')) return true;
    if (!menuDetails || !menuDetails.isConnected) menuDetails = document.querySelector('header-drawer details');
    return !!(menuDetails && (menuDetails.open || menuDetails.classList.contains('menu-open')));
  }
  window.__hvPaused = hvPaused;

  /* ---------- wordmark light: follows the pointer, drifts on its own otherwise ---------- */
  let px0 = -1, py0 = -1, pointerAt = 0;
  addEventListener('pointermove', (e) => { if (e.pointerType === 'touch') return; px0 = e.clientX; py0 = e.clientY; pointerAt = performance.now(); }, { passive: true });
  let sheenEls = [], sheenRects = [], sheenAt = 0;
  (function drift(t) {
    if (t - sheenAt > 160) { sheenAt = t; sheenEls = $$('[data-hv-sheen]'); sheenRects = sheenEls.map((el) => el.getBoundingClientRect()); }
    if (!REDUCED && !hvPaused()) sheenEls.forEach((sh, i) => {
      const r = sheenRects[i];
      if (!r.width || r.bottom < 0 || r.top > innerHeight) return;
      const idle = t - pointerAt > 2500;
      const x = idle ? .5 + Math.sin(t / 2600 + i) * .42 : Math.min(1.2, Math.max(-.2, (px0 - r.left) / r.width));
      const y = idle ? .3 + Math.cos(t / 3400 + i) * .18 : Math.min(1.2, Math.max(-.2, (py0 - r.top) / r.height));
      const cx = (parseFloat(sh.style.getPropertyValue('--lx')) || 50) / 100, cy = (parseFloat(sh.style.getPropertyValue('--ly')) || 35) / 100;
      sh.style.setProperty('--lx', ((cx + (x - cx) * .08) * 100).toFixed(2) + '%');
      sh.style.setProperty('--ly', ((cy + (y - cy) * .08) * 100).toFixed(2) + '%');
    });
    requestAnimationFrame(drift);
  })(performance.now());

  /* ---------- reveal + counters ---------- */
  let io;
  function observeReveals() {
    io && io.disconnect();
    io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      io.unobserve(e.target);
      $$('[data-count]', e.target).forEach((el) => {
        const to = +el.dataset.count;
        if (REDUCED || DESIGN || !isFinite(to)) return;
        const t0 = performance.now();
        (function tick(t) { const p = Math.min(1, (t - t0) / 1400); el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(tick); })(t0);
      });
    }), { threshold: 0.2 });
    $$('.hv-rv').forEach((el) => io.observe(el));
  }

  /* ---------- boot ---------- */
  function refresh() { readCfg(); collect(); observeReveals(); setTheme(); chapterStates(); heroWord(); three && three.refresh(); }
  let three = null;
  function onScroll() { if (!three || !three.running) { setTheme(); chapterStates(); heroWord(); } }
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  addEventListener('resize', () => { measure(); onScroll(); });
  addEventListener('load', () => { measure(); onScroll(); });
  if (document.fonts) document.fonts.ready.then(measure);
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((ev) => document.addEventListener(ev, () => setTimeout(refresh, 30)));
  document.addEventListener('shopify:section:select', (e) => setTimeout(() => { measure(); e.target && window.__hvScrollTo && e.target.scrollIntoView({ block: 'start' }); }, 30));

  readCfg();
  collect();
  observeReveals();
  setTheme();
  chapterStates();
  heroWord();
  // re-measure once the page has settled (images, header)
  setTimeout(measure, 400);

  /* =========================================================================
     3D
     ========================================================================= */
  let glOK;
  function webglOK() {
    if (!window.THREE) return false;
    if (glOK !== undefined) return glOK;
    try {
      const c = document.createElement('canvas'), gl = c.getContext('webgl') || c.getContext('experimental-webgl');
      glOK = !!gl; const ext = gl && gl.getExtension('WEBGL_lose_context'); if (ext) ext.loseContext();
    } catch (e) { glOK = false; }
    return glOK;
  }
  // Generic pose fields every model understands; models add their own state keys (heat, lid, tablet...)
  const BASE_POSE = { mpy: .3, rx: 0, ry: 0, rz: 0, px: 0, py: 0, s: 1, spin: 0, op: 1, drag: 0, fx: 0, fy: 0, fz: 0, track: 0 };
  function modelFor(name) {
    const all = window.HoveModels || {};
    return all[name] || all.neckband;
  }
  function posesFor(M) {
    const P = {};
    const base = Object.assign({}, BASE_POSE, M.defaults || {});
    Object.entries(M.poses).forEach(([k, v]) => { P[k] = Object.assign({}, base, v); });
    if (!P.hidden) P.hidden = Object.assign({}, P.hero || base, { op: 0, spin: 0 });
    P.track = Object.assign({}, P.showcase || P.hero || base, { track: 1, spin: 1, px: 0, py: 0, s: 1, mpy: 0, op: 1 });
    if (window.__hvExtraPoses) Object.entries(window.__hvExtraPoses).forEach(([k, v]) => { P[k] = Object.assign({}, base, v); });
    const keys = new Set(Object.keys(base));
    Object.values(P).forEach((o) => Object.keys(o).forEach((k) => keys.add(k)));
    const KEYS = [...keys];
    Object.values(P).forEach((o) => KEYS.forEach((k) => { if (o[k] == null) o[k] = base[k] != null ? base[k] : 0; }));
    return { P, KEYS };
  }
  // place a model: Y-then-X (neckband) or Euler XYZ (other models), then move the focus point to the target
  function placeModel(M, model, tilt, cur, extraY, scale, tx, ty) {
    if (M.euler === 'xyz') { model.rotation.set(cur.rx, cur.ry + extraY, cur.rz, 'XYZ'); tilt.rotation.set(0, 0, 0); }
    else { model.rotation.set(0, cur.ry + extraY, 0); tilt.rotation.set(cur.rx, 0, cur.rz); }
    model.scale.setScalar(scale);
    const f = placeModel.v || (placeModel.v = new window.THREE.Vector3());
    f.set(cur.fx || 0, cur.fy || 0, cur.fz || 0).applyQuaternion(tilt.quaternion).applyQuaternion(model.quaternion).multiplyScalar(scale);
    model.position.set(tx - f.x, ty - f.y, -f.z);
  }
  function addLights(THREE, scene, size, area) {
    const key = new THREE.DirectionalLight(0xffffff, .9); key.position.set(-4, 6, 5); scene.add(key);
    key.castShadow = true; key.shadow.mapSize.set(size, size); key.shadow.bias = -.0004; key.shadow.normalBias = .02; key.shadow.radius = 4;
    const r = area || (size > 1024 ? 4 : 2.8);
    Object.assign(key.shadow.camera, { left: -r, right: r, top: r, bottom: -r, near: .5, far: 20 });
    const rimL = new THREE.DirectionalLight(0xffffff, .3); rimL.position.set(5, 1, -4); scene.add(rimL);
    scene.add(new THREE.HemisphereLight(0xffffff, 0x9a9ea6, .15));
  }
  function registerUnit(unit) {
    (window.__hvUnits = window.__hvUnits || []).push(unit);
    if (!window.__hvSetAccent) window.__hvSetAccent = (h) => { window.__hvAccent = h; (window.__hvUnits || []).forEach((un) => un.setAccent && un.setAccent(h, REDUCED)); };
  }

  function start3D() {
    let stageEl = $('[data-hv-canvas]');
    if (!stageEl || cfg.enable3d !== 'true' || !webglOK() || !window.HoveModels) { document.documentElement.classList.add('hv-no3d'); return null; }
    document.documentElement.classList.remove('hv-no3d');
    const THREE = window.THREE;
    const M = modelFor(cfg.model);
    const { P: POSES, KEYS } = posesFor(M);
    function trackTarget() {
      let best = null, bd = Infinity;
      $$('[data-hv-track]').forEach((el) => { const r = el.getBoundingClientRect(); const d = Math.abs(r.top + r.height / 2 - innerHeight / 2); if (d < bd && r.width) { bd = d; best = r; } });
      if (!best) return null;
      const cx = (best.left + best.width / 2) / innerWidth * 2 - 1, cy = -((best.top + best.height / 2) / innerHeight * 2 - 1);
      const w = best.width / innerWidth * halfW * 2, h = best.height / innerHeight * halfH * 2;
      return { x: cx * halfW, y: cy * halfH, s: Math.min(w / 2.35, h / 2.1) };
    }
    const poseOf = (s) => POSES[s.dataset.hvPose] || POSES.hidden;
    const cur = Object.assign({}, poseOf(secs[0] || document.body));

    const small = innerWidth <= 760;
    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance' });
    renderer.setPixelRatio(Math.min(devicePixelRatio || 1, small ? 1.5 : 2));
    renderer.domElement.addEventListener('webglcontextlost', (e) => { e.preventDefault(); document.documentElement.classList.add('hv-no3d'); }, { once: true });
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = .92;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    stageEl.appendChild(renderer.domElement);
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(30, 1, 0.1, 100);
    camera.position.set(0, 0, 8.5);
    scene.environment = HoveUnit.studioEnv(THREE, renderer);
    addLights(THREE, scene, small ? 1024 : 2048, 4);

    const sm = (a, b, x) => { const t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); };
    const lerp = (a, b, t) => a + (b - a) * t;

    const unit = M.build(THREE, { shadows: true, accent: window.__hvAccent || cfg.defaultAccent, lite: innerWidth <= 760 });
    registerUnit(unit);
    const model = new THREE.Group(), tilt = new THREE.Group();
    model.add(tilt); tilt.add(unit.body); scene.add(model);
    if (unit.extras) scene.add(unit.extras);

    const shTex = (() => { const c = document.createElement('canvas'); c.width = 256; c.height = 128; const g = c.getContext('2d'); const gr = g.createRadialGradient(128, 64, 0, 128, 64, 128); gr.addColorStop(0, 'rgba(0,0,0,.38)'); gr.addColorStop(1, 'rgba(0,0,0,0)'); g.setTransform(1, 0, 0, .5, 0, 32); g.fillStyle = gr; g.fillRect(0, -64, 256, 256); return new THREE.CanvasTexture(c); })();
    const shadow = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), new THREE.MeshBasicMaterial({ map: shTex, transparent: true, depthWrite: false, opacity: 0 }));
    shadow.rotation.x = -Math.PI / 2; scene.add(shadow);

    let halfW = 1, halfH = 1, mobile = false;
    let lastW = 0, lastH = 0;
    function resize() {
      const w = innerWidth, h = innerHeight;
      if (w === lastW && Math.abs(h - lastH) < h * .2) { measure(); return; }
      lastW = w; lastH = h; renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix();
      halfH = Math.tan(THREE.MathUtils.degToRad(15)) * camera.position.z; halfW = halfH * camera.aspect; mobile = w <= 760; measure();
    }
    addEventListener('resize', resize); resize();

    let drag = 0, dragV = 0, dragging = false, lx = 0;
    function wireDrag() {
      $$('[data-hv-drag]').forEach((dz) => {
        if (dz.__hvWired) return; dz.__hvWired = true;
        dz.addEventListener('pointerdown', (e) => { dragging = true; lx = e.clientX; try { dz.setPointerCapture(e.pointerId); } catch (_) {} });
        dz.addEventListener('pointermove', (e) => { if (!dragging) return; const d = (e.clientX - lx) * .01; lx = e.clientX; drag += d; dragV = d; });
        const end = () => { dragging = false; }; dz.addEventListener('pointerup', end); dz.addEventListener('pointercancel', end);
        dz.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') { drag -= .3; e.preventDefault(); } if (e.key === 'ArrowRight') { drag += .3; e.preventDefault(); } });
      });
    }
    wireDrag();

    const target = {};
    function computeTarget(y) {
      if (!secs.length) return;
      const vh = innerHeight, hold = vh * .22;
      let i = 0; while (i < anchors.length - 1 && y >= anchors[i + 1]) i++;
      const a = poseOf(secs[i]), b = poseOf(secs[Math.min(i + 1, secs.length - 1)]);
      let t = 0;
      if (i < anchors.length - 1) { const span = anchors[i + 1] - anchors[i]; t = span > 0 ? sm(0, 1, (y - anchors[i] - hold) / Math.max(1, span - 2 * hold)) : 0; }
      if (y < anchors[0]) t = 0;
      KEYS.forEach((k) => (target[k] = lerp(a[k], b[k], t)));
      // fade the model out quickly between a shown and a hidden section, so a half-transparent ghost never hangs over content
      target.op = sm(.6, 1, target.op);
      const last = secs[secs.length - 1];
      if (last && last.getBoundingClientRect().bottom < innerHeight * .5) target.op = 0;
      if (innerWidth <= 860 && $('[data-hv-mini-mobile]')) target.op *= 1 - target.drag;
    }

    let twin = null, twinT = 0;
    function ensureTwin() {
      if (twin) return twin;
      const u = M.build(THREE, { shadows: true, accent: (window.__hvTwin || {}).accent || window.__hvAccent || cfg.defaultAccent, lite: innerWidth <= 760 });
      const m = new THREE.Group(), t = new THREE.Group(); m.add(t); t.add(u.body); m.visible = false; scene.add(m);
      const sh = shadow.clone(); sh.material = shadow.material.clone(); sh.visible = false; scene.add(sh);
      twin = { u, m, t, sh, dims: null, accent: null };
      return twin;
    }
    let spinA = 0, last = performance.now(), intro = REDUCED ? 1 : 0, visible = true;
    const box = new THREE.Box3(), v3 = new THREE.Vector3(), size = new THREE.Vector3();
    document.addEventListener('visibilitychange', () => { visible = !document.hidden; last = performance.now(); });
    const fit = M.fit || 3.1, mobS = M.mobileScale || .45;
    let lastY = NaN;
    addEventListener('resize', () => { lastY = NaN; });
    function frame(now) {
      requestAnimationFrame(frame);
      if (!visible || hvPaused()) { last = now; lastY = NaN; return; }
      const dt = Math.max(0, Math.min(.05, (now - last) / 1000)); last = Math.max(last, now);
      const y = scrollTop();
      if (y !== lastY) { lastY = y; computeTarget(y); setTheme(); chapterStates(); heroWord(); }
      const k = REDUCED ? 1 : 1 - Math.exp(-dt * 5.5);
      KEYS.forEach((key) => (cur[key] = lerp(cur[key], target[key] ?? cur[key], k)));
      // the intro settles facing front, then the slow spin begins
      if (!REDUCED && intro >= 1) spinA += dt * .5 * cur.spin; spinA = Math.atan2(Math.sin(spinA), Math.cos(spinA));
      if (!dragging) { drag += dragV; dragV *= .92; }
      if (!dragging && target.drag < .05) { drag *= Math.exp(-dt * 4); dragV = 0; }
      intro = Math.min(1, intro + dt * .7); const ie = 1 - Math.pow(1 - intro, 3);

      const sf = Math.min(1, (halfW * 2) / fit) * (mobile ? .92 : 1);
      let s = (mobile ? 1 + (cur.s - 1) * mobS : cur.s) * sf * (.82 + .18 * ie);
      let tx = mobile ? 0 : cur.px * halfW * .5;
      let ty = (mobile ? (cur.py * .4 + halfH * cur.mpy) : cur.py) + (1 - ie) * -.4;
      if (cur.track > .001) { const tt = trackTarget(); if (tt) { tx = lerp(tx, tt.x, cur.track); ty = lerp(ty, tt.y, cur.track); s = lerp(s, tt.s, cur.track); } }
      placeModel(M, model, tilt, cur, spinA * cur.spin + drag * cur.drag + (1 - ie) * -1.2, s, tx, ty);
      const opS = (cur.op * ie).toFixed(3); if (opS !== stageEl.__hvOp) stageEl.style.opacity = stageEl.__hvOp = opS;
      unit.update(dt, now / 1000, cur, { px: tx, py: ty, sf, mobile, scale: s });

      // two-pack: a second unit in the second finish slides in beside the first, only while the buy box is on screen
      const tsn = window.__hvTwin || {}, twWant = tsn.on && target.drag > .5 && cur.drag > .3 ? 1 : 0;
      twinT = REDUCED ? twWant : lerp(twinT, twWant, 1 - Math.exp(-dt * 4));
      if (twinT > .004 || twWant) {
        const T = ensureTwin(), e = sm(0, 1, twinT), k2 = 1 - .4 * e, gap = s * k2 * (M.twinGap || 1.3);
        if (tsn.accent && tsn.accent !== T.accent) { T.accent = tsn.accent; T.u.setAccent && T.u.setAccent(tsn.accent, !T.m.visible); }
        const ang = spinA * cur.spin + drag * cur.drag;
        if (!T.dims) T.dims = measurePosed(THREE, M, T.m, T.t, cur);
        placeModel(M, model, tilt, cur, ang, s * k2, tx, ty);
        const off = pairOffset(THREE, (cur.ry || 0) + ang, T.dims, s * k2), slide = 1 - e;
        model.position.addScaledVector(off, -.5 * e);
        placeModel(M, T.m, T.t, cur, ang, s * k2 * (.6 + .4 * e), tx, ty);
        T.m.position.copy(model.position).add(off).add(new THREE.Vector3(gap * 1.6 * slide, 0, 0)); T.m.visible = e > .004;
        T.u.update(dt, now / 1000, cur, { px: tx, py: ty, sf, mobile, scale: s });
        box.setFromObject(T.m); box.getCenter(v3); box.getSize(size);
        T.sh.visible = T.m.visible; T.sh.position.set(v3.x, box.min.y - .03, v3.z); T.sh.scale.set(size.x * 1.25 + .2, size.z * 1.1 + .4, 1);
        T.sh.material.opacity = shadow.material.opacity * e;
      } else if (twin) { twin.m.visible = false; twin.sh.visible = false; twin.dims = null; }

      const light = document.body.dataset.hvBg !== 'dark';
      box.setFromObject(model); box.getCenter(v3); box.getSize(size);
      shadow.position.set(v3.x, box.min.y - .03, v3.z);
      shadow.scale.set(size.x * 1.25 + .2, size.z * 1.1 + .4, 1);
      shadow.material.opacity = lerp(shadow.material.opacity, light ? .9 : 0, k);

      if (cur.op > .004) renderer.render(scene, camera);
    }
    requestAnimationFrame(frame);
    return { running: true, refresh() {
      wireDrag(); measure(); lastY = NaN;
      const ne = $('[data-hv-canvas]');
      if (ne && ne !== stageEl) { ne.appendChild(renderer.domElement); stageEl = ne; }
      document.documentElement.classList.toggle('hv-no3d', !ne || cfg.enable3d !== 'true');
      if (window.__hvSetAccent) window.__hvSetAccent(window.__hvAccent || cfg.defaultAccent);
    } };
  }

  // bounding box of only what's actually showing (hidden straps, faded covers and effects don't count)
  function visibleBox(THREE, root) {
    const box = new THREE.Box3(), tmp = new THREE.Box3();
    root.updateMatrixWorld(true);
    root.traverseVisible((o) => {
      if (!o.isMesh || !o.geometry) return;
      const mats = Array.isArray(o.material) ? o.material : [o.material];
      if (mats.every((m) => !m || m.visible === false || (m.transparent && m.opacity < .1) || m.blending === THREE.AdditiveBlending)) return;
      if (!o.geometry.boundingBox) o.geometry.computeBoundingBox();
      tmp.copy(o.geometry.boundingBox).applyMatrix4(o.matrixWorld); box.union(tmp);
    });
    return box.isEmpty() ? new THREE.Box3().setFromObject(root) : box;
  }

  // two-pack layout: the second unit sits a full product-depth behind the first and half a width to the side, in the
  // pair's own frame, so the two never pass through each other while they turn together
  // measure the unit as it is posed (tilt applied, no turn), so width and depth are what the viewer sees
  function measurePosed(THREE, M, grp, tgrp, pose) {
    const p = Object.assign({}, pose, { fx: 0, fy: 0, fz: 0 });
    placeModel(M, grp, tgrp, p, -(p.ry || 0), 1, 0, 0); grp.updateMatrixWorld(true);
    const sz = visibleBox(THREE, grp).getSize(new THREE.Vector3()); return { W: Math.max(sz.x, .5), D: Math.max(sz.z, .3) };
  }
  // offset stays horizontal: it turns with the pair's yaw only
  function pairOffset(THREE, yaw, dims, scale) {
    return new THREE.Vector3(dims.W * .8, 0, -dims.D * 1.1).multiplyScalar(scale).applyAxisAngle(new THREE.Vector3(0, 1, 0), yaw);
  }

  /* ---------- inline viewers: a small 3D canvas that lives inside a box and scrolls with it ---------- */
  function createMini(el) {
    const THREE = window.THREE;
    const M = modelFor(el.dataset.hvMiniModel || cfg.model);
    const { P } = posesFor(M);
    const pose = Object.assign({}, P[el.dataset.hvMiniPose] || P[M.miniPose] || P.hero);
    if (el.dataset.hvMiniTilt) pose.rx = parseFloat(el.dataset.hvMiniTilt);
    if (M.miniRy != null) pose.ry = M.miniRy;
    pose.fx = pose.fy = pose.fz = 0;
    const cv = document.createElement('canvas'); cv.className = 'hv-mini-canvas'; cv.setAttribute('aria-hidden', 'true');
    const renderer = new THREE.WebGLRenderer({ canvas: cv, antialias: true, alpha: true });
    el.appendChild(cv);
    renderer.setPixelRatio(Math.min(devicePixelRatio || 1, 1.75));
    let dead = false;
    cv.addEventListener('webglcontextlost', (e) => { e.preventDefault(); dead = true; el.classList.remove('hv-mini--on'); el.classList.add('hv-mini--off'); }, { once: true });
    renderer.outputEncoding = THREE.sRGBEncoding; renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = .92;
    renderer.shadowMap.enabled = true; renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    const scene = new THREE.Scene(); scene.environment = HoveUnit.studioEnv(THREE, renderer);
    const camera = new THREE.PerspectiveCamera(28, 1, .1, 50); camera.position.set(0, 0, 7.4);
    addLights(THREE, scene, 1024);
    const unit = M.build(THREE, { shadows: true, lite: innerWidth <= 760, accent: window.__hvAccent || cfg.defaultAccent, mini: true });
    registerUnit(unit);
    const model = new THREE.Group(), tilt = new THREE.Group(); model.add(tilt); tilt.add(unit.body); scene.add(model);
    const sc = document.createElement('canvas'); sc.width = 256; sc.height = 128; const sg = sc.getContext('2d');
    const gr = sg.createRadialGradient(128, 64, 0, 128, 64, 128); gr.addColorStop(0, 'rgba(0,0,0,.32)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
    sg.setTransform(1, 0, 0, .5, 0, 32); sg.fillStyle = gr; sg.fillRect(0, -64, 256, 256);
    const floor = new THREE.Mesh(new THREE.PlaneGeometry(3.2, 1.6), new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(sc), transparent: true, depthWrite: false }));
    floor.rotation.x = -Math.PI / 2; scene.add(floor);

    let W = 0, H = 0, baseY = 0, fitScale = 1, spanW = 1, baseX = 0;
    function fit() {
      const r = el.getBoundingClientRect(); W = Math.max(1, r.width); H = Math.max(1, r.height);
      renderer.setSize(W, H, false); camera.aspect = W / H; camera.updateProjectionMatrix();
      const halfH = Math.tan(THREE.MathUtils.degToRad(14)) * camera.position.z, halfW = halfH * camera.aspect;
      unit.update(0, 0, pose, { mini: true });
      // turn around the middle of the visible product, so it stays centred while it sways or is dragged
      if (!unit.__hvHome) unit.__hvHome = unit.body.position.clone();
      unit.body.position.copy(unit.__hvHome); model.position.set(0, 0, 0); model.rotation.set(0, 0, 0); model.scale.setScalar(1); tilt.rotation.set(0, 0, 0);
      const ctr = visibleBox(THREE, model).getCenter(new THREE.Vector3()); unit.body.position.sub(ctr);
      placeModel(M, model, tilt, pose, 0, 1, 0, 0); model.updateMatrixWorld(true);
      const bb = visibleBox(THREE, unit.body), sz = bb.getSize(new THREE.Vector3());
      const span = Math.max(sz.x, sz.z * .8, .01), tall = Math.max(sz.y, .01);
      fitScale = Math.min(halfW * 2 * .82 / span, halfH * 2 * .78 / tall) * parseFloat(el.dataset.hvMiniScale || '1');
      placeModel(M, model, tilt, pose, 0, fitScale, 0, 0); model.updateMatrixWorld(true);
      const bb2 = visibleBox(THREE, unit.body), c = bb2.getCenter(new THREE.Vector3());
      baseY = -c.y + halfH * .04; model.position.x -= c.x; spanW = sz.x * fitScale; baseX = model.position.x;
      floor.position.y = bb2.min.y + baseY - .04; floor.scale.set(Math.max(.6, sz.x * fitScale * .45), sz.z * fitScale * .55 + .3, 1);
    }
    fit();
    let ro = null, cssHidden = false;
    const fitAll = () => { cssHidden = cv.offsetParent === null || getComputedStyle(cv).display === 'none'; if (!cssHidden) fit(); };
    if (window.ResizeObserver) { ro = new ResizeObserver(fitAll); ro.observe(el); } else addEventListener('resize', fitAll);

    let spin = 0, drag = 0, dragV = 0, dragging = false, lx = 0, onScreen = true, last = performance.now();
    el.addEventListener('pointerdown', (e) => { dragging = true; lx = e.clientX; try { el.setPointerCapture(e.pointerId); } catch (_) {} });
    el.addEventListener('pointermove', (e) => { if (!dragging) return; const d = (e.clientX - lx) * .012; lx = e.clientX; drag += d; dragV = d; });
    const end = () => { dragging = false; }; el.addEventListener('pointerup', end); el.addEventListener('pointercancel', end);
    el.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') { drag -= .3; e.preventDefault(); } if (e.key === 'ArrowRight') { drag += .3; e.preventDefault(); } });
    let idle = 0;
    el.addEventListener('pointerdown', () => { idle = 0; });
    const isBuy = el.hasAttribute('data-hv-drag');
    let mtwin = null, mtw = 0;
    function ensureMiniTwin() {
      if (mtwin) return mtwin;
      const u = M.build(THREE, { shadows: true, lite: true, accent: (window.__hvTwin || {}).accent || window.__hvAccent || cfg.defaultAccent, mini: true });
      const m = new THREE.Group(), t = new THREE.Group(); m.add(t); t.add(u.body); m.visible = false; scene.add(m);
      if (unit.__hvHome) { u.body.position.copy(unit.body.position); }
      mtwin = { u, m, t, dims: null, accent: null };
      return mtwin;
    }
    let io = null;
    if (window.IntersectionObserver) (io = new IntersectionObserver((es) => { const was = onScreen; onScreen = es[0].isIntersecting; last = performance.now(); if (onScreen && !was) { spin = 0; drag = 0; dragV = 0; idle = 0; mtw = 0; } cssHidden = cv.offsetParent === null; }, { rootMargin: '0px' })).observe(el);
    (function loop(now) {
      if (dead) return;
      requestAnimationFrame(loop);
      if (!onScreen || document.hidden || !cv.isConnected || cssHidden || hvPaused()) { last = now; return; }
      const dt = Math.max(0, Math.min(.05, (now - last) / 1000)); last = Math.max(last, now);
      if (!REDUCED && !dragging) spin += dt;
      if (!dragging) { drag += dragV; dragV *= .92; idle += dt; if (idle > 2.5) { drag = Math.atan2(Math.sin(drag), Math.cos(drag)) * Math.exp(-dt * 1.6); } }
      const sway = REDUCED ? 0 : Math.sin(spin * .55) * .38;
      const x0 = baseX;
      placeModel(M, model, tilt, pose, sway + drag, fitScale, x0, 0);
      model.position.x = x0; model.position.y = baseY + (REDUCED ? 0 : Math.sin(now / 1400) * .025);
      unit.update(dt, now / 1000, pose, { mini: true });
      if (isBuy) {
        const tsn = window.__hvTwin || {}, want = tsn.on ? 1 : 0;
        mtw = REDUCED ? want : mtw + (want - mtw) * (1 - Math.exp(-dt * 4));
        if (mtw > .004 || want) {
          const T = ensureMiniTwin(), e = mtw * mtw * (3 - 2 * mtw), k = 1 - .45 * e;
          if (tsn.accent && tsn.accent !== T.accent) { T.accent = tsn.accent; T.u.setAccent && T.u.setAccent(tsn.accent, !T.m.visible); }
          placeModel(M, model, tilt, pose, sway + drag, fitScale * k, x0, 0); model.position.y = baseY + (REDUCED ? 0 : Math.sin(now / 1400) * .025);
          if (!T.dims) T.dims = measurePosed(THREE, M, T.m, T.t, pose);
          const po = pairOffset(THREE, (pose.ry || 0) + sway + drag, T.dims, fitScale * k);
          model.position.addScaledVector(po, -.5 * e);
          placeModel(M, T.m, T.t, pose, sway + drag, fitScale * k * (.6 + .4 * e), x0, 0);
          T.m.position.copy(model.position).add(po).add(new THREE.Vector3((1 - e) * spanW * .7, 0, 0)); T.m.visible = e > .004;
          T.u.update(dt, now / 1000, pose, { mini: true });
        } else if (mtwin) mtwin.m.visible = false;
      }
      renderer.render(scene, camera);
    })(performance.now());
    function dispose() {
      if (dead) return; dead = true;
      if (io) io.disconnect(); if (ro) ro.disconnect();
      const all = window.__hvUnits; if (all) { const i = all.indexOf(unit); if (i > -1) all.splice(i, 1); }
      scene.traverse((o) => { if (o.geometry) o.geometry.dispose(); const ms = o.material ? (Array.isArray(o.material) ? o.material : [o.material]) : []; ms.forEach((m) => { Object.values(m).forEach((v) => v && v.isTexture && v.dispose()); m.dispose(); }); });
      if (scene.environment) scene.environment.dispose();
      renderer.dispose(); try { renderer.forceContextLoss(); } catch (_) {}
      cv.remove();
    }
    return { fit, dispose };
  }
  function initMini(el) {
    if (el.__hvMini) return;
    if (el.hasAttribute('data-hv-mini-mobile') && innerWidth > 860) return;
    const name = el.dataset.hvMiniModel || cfg.model;
    if (name && !(window.HoveModels || {})[name]) return; // its model file hasn't run yet; a later pass retries
    try { el.__hvMini = createMini(el); el.classList.add('hv-mini--on'); }
    catch (e) { console.warn('[hove] inline 3D off', e); el.__hvMini = { failed: true }; $$('canvas.hv-mini-canvas', el).forEach((c) => c.remove()); el.classList.add('hv-mini--off'); }
  }
  let miniIO = null;
  function startMinis() {
    if (!window.THREE || !window.HoveModels || cfg.enable3d !== 'true' || !webglOK()) return;
    if (!miniIO && window.IntersectionObserver) miniIO = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { initMini(e.target); if (e.target.__hvMini) miniIO.unobserve(e.target); } }), { rootMargin: '400px 0px' });
    $$('[data-hv-mini]').forEach((el) => {
      if (el.__hvMini || el.__hvWatched) return;
      if (miniIO) { el.__hvWatched = true; miniIO.observe(el); } else initMini(el);
    });
  }
  addEventListener('resize', () => { if (innerWidth <= 860 && miniIO) $$('[data-hv-mini-mobile]').forEach((el) => { if (!el.__hvMini && el.__hvWatched) { miniIO.unobserve(el); miniIO.observe(el); } }); });
  document.addEventListener('shopify:section:load', () => setTimeout(startMinis, 80));
  document.addEventListener('shopify:section:unload', (e) => $$('[data-hv-mini]', e.target).forEach((el) => { if (el.__hvMini && el.__hvMini.dispose) el.__hvMini.dispose(); if (miniIO) miniIO.unobserve(el); }));

  function safeStart() {
    try { return start3D(); }
    catch (e) {
      console.warn('[hove] 3D off', e);
      $$('[data-hv-canvas] canvas').forEach((c) => c.remove());
      document.documentElement.classList.add('hv-no3d');
      return { failed: true };
    }
  }
  function boot3D() {
    if (three) return;
    if (!stageRoot()) return;
    if (window.THREE) { three = safeStart(); startMinis(); return; }
    // deferred scripts have all run by now, so three.js failed to load (blocked or offline): show the product images
    document.documentElement.classList.add('hv-no3d');
    const s = $('script[data-hv-three]');
    if (s && !s.__hvWait) { s.__hvWait = true; s.addEventListener('load', () => { if (!three) { three = safeStart(); startMinis(); } }, { once: true }); }
  }
  // wait for every deferred script (three.js and the product model files) before building the scene
  if (document.readyState !== 'complete' && document.readyState !== 'loaded') document.addEventListener('DOMContentLoaded', boot3D); else boot3D();
  addEventListener('load', () => { if (!three) boot3D(); });
  document.addEventListener('shopify:section:load', () => setTimeout(() => { if (!three) boot3D(); }, 60));
})();
